import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from '../../utils/secureStorage';

const PrivateRoute = ({ children }) => {
  return getToken('accessToken') ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
